import library_fr from "@nuxtDatakodeUtils/lang/fr.js";
import lang_fr09 from "@/lang/09";
import lang_fr31 from "@/lang/31";
import lang_fr64 from "@/lang/64.js";
import lang_fr65 from "@/lang/65";
import lang_fr12 from "@/lang/12";
import permissions_fr from "@/lang/permissions.js";
import lang_fr from "@/lang/fr";
function deepMerge(obj1, obj2) {
	// console.log('obj1', obj1, obj2)
	const defaultLang = { ...obj1 };
	for (const key in obj2) {
		// eslint-disable-next-line no-prototype-builtins
		if (obj2.hasOwnProperty(key)) {
			if (obj2[key] instanceof Object && defaultLang[key] instanceof Object) {
				defaultLang[key] = deepMerge(defaultLang[key], obj2[key]);
			} else {
				defaultLang[key] = obj2[key];
			}
		}
	}
	return defaultLang;
}
// eslint-disable-next-line prefer-const
let lang = {
	...lang_fr,
	...permissions_fr,
	...library_fr
};
export default () => ({
	// locale: 'fr',
	missingWarn: false,
	fallbackWarn: false,
	silentTranslationWarn: true,
	warnHtmlMessage: false,
	runtimeOnly: false,
	messages: {
		"fr": lang,
		"09": deepMerge(lang, lang_fr09),
		"31": deepMerge(lang, lang_fr31),
		"64": deepMerge(lang, lang_fr64),
		"65": deepMerge(lang, lang_fr65),
		"12": deepMerge(lang, lang_fr12)
	}
});
